import initialState from "./initialState";

export function TopFocusItemsReducer(
  state = initialState.TopFocusItemsReducer,
  action
) {
  switch (action.type) {
    case "SEARCH_TOP_FOCUS_ITEMS_REQUEST":
      return action.payload;

    default:
      return state;
  }
}
